var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMergeContacts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3334 3.6125V5.94688C20.3334 7.28312 19.8208 8.53875 18.8909 9.48313L14.2854 14.1606C14.1771 14.2706 14.0829 14.3906 13.998 14.5156C13.7783 13.6506 13.3574 12.8525 12.7586 12.1756L17.1512 7.71438C17.6158 7.2425 17.8718 6.61438 17.8718 5.94688V3.6125C17.8718 3.6125 17.8718 2.5 19.1026 2.5C20.3334 2.5 20.3334 3.6125 20.3334 3.6125ZM13.5641 17.7144V15.9281C13.5641 14.5919 13.0515 13.3363 12.1217 12.3925L7.51614 7.71375C7.05091 7.2425 6.79491 6.61438 6.79491 5.94688V3.6125C6.79491 3.6125 6.79491 2.5 5.56414 2.5C4.33337 2.5 4.33337 3.6125 4.33337 3.6125V5.94688C4.33337 7.28312 4.84599 8.53875 5.77583 9.4825L10.3814 14.1613C10.8466 14.6325 11.1026 15.2606 11.1026 15.9281V17.7144L10.3038 16.9031C10.3038 16.9031 9.49548 16.1151 8.63491 16.9756C7.77434 17.8362 8.63491 18.7295 8.63491 18.7295L12.3334 22.5L16.0324 18.7295C16.0324 18.7295 17.0081 17.9513 16.0324 16.9756C15.0568 16 14.3334 16.9208 14.3334 16.9208L13.5641 17.7144Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMergeContacts);
export default __webpack_public_path__ + "static/media/merge-contacts.a5de1c146d10334894e652e3a73a41cd.svg";
export { ForwardRef as ReactComponent };